






































































































import { defineComponent, ref } from '@vue/composition-api';
import { CheckRectangleIcon, ViewModuleIcon } from 'tdesign-icons-vue';

import CollectFileDialog from '@/renderer/components/dialog/FileCollect/components/CollectFileDialog.vue';
import listOperateHandler from '@/renderer/scripts/composition/listOperateHandler';
import { setResizableColumns } from '@/renderer/scripts/composition/tableResizeHandler';

import { overCurrentTime } from '@/renderer/scripts/utils/dayjsUsage';
import { dispatchRouter } from '@/renderer/scripts/utils/tools/dispatchRouter';
import { IS_BROWSER } from '@/common/constant/platform';
import { httpUrl } from '@/renderer/scripts/http';
import collectedFileTableHandler from '../composition/collectedFileTableHandler';

export default defineComponent({
  name: 'CollectedFileTable',
  components: {
    CheckRectangleIcon,
    CollectFileDialog,
    ViewModuleIcon,
  },
  setup() {
    const { columns, tableData, loading, pageData, sort, methods: listMethods } = collectedFileTableHandler();
    const {
      operateShowMap,
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      methods: listOperateMethods,
    } = listOperateHandler({
      ...tableData,
      selectedRowKeys: [],
      selectedList: [],
    });
    const showColelctFileDialog = ref(false);
    const code = ref('');
    const isSubmit = ref(false);
    const resizeColumns = ref(setResizableColumns(columns));

    const methods = {
      submitFile(
        row: {
          code: string;
        },
        flag: boolean,
      ) {
        isSubmit.value = flag;
        code.value = row.code;
        if (IS_BROWSER) {
          showColelctFileDialog.value = true;
        } else {
          dispatchRouter(`${httpUrl.webUrl}/web/collect/${row.code}`);
        }
      },
      taskIsInvalid(item: { path: string[]; status: number }) {
        return !item.path || !item.status;
      },
      canSumbit(row: { path: string[]; status: number; expireTime: string }) {
        return row.path && row.status === 1 && !overCurrentTime(new Date(), row.expireTime);
      },
    };
    return {
      listMethods,
      sort,
      pageData,
      loading,
      resizeColumns,
      tableData,
      hoverIndex,
      isFirstButtonHover,
      isSecondButtonHover,
      operateShowMap,
      overCurrentTime,
      listOperateMethods,
      showColelctFileDialog,
      code,
      isSubmit,
      ...methods,
    };
  },
});
